export default class JiraIssueItem {
  constructor(item) {
    if (item === undefined) {
      this.JiraIssueId = '';
      this.JiraId = '';
      this.Key = '';
      this.Summary = '';
      this.AssigneeDisplayName = '';
      this.BusinessOwner = '';
      this.IssueCreatedOn = '';
      this.BravoTitle = '';
      this.BravoDescription = '';
      this.TargetDate = null;
      this.StatusName = '';
      this.DevelopmentType = '';
      this.StatusCategoryChangeDate = null;
      return;
    }
    this.initialize(item);
  }

  initialize(item) {
    this.JiraIssueId = item.jiraIssueId;
    this.JiraId = item.jiraId;
    this.Key = item.key;
    this.Summary = item.summary;
    this.AssigneeDisplayName = item.assigneeDisplayName;
    this.BusinessOwner = item.businessOwner;
    this.IssueCreatedOn = item.issueCreatedOn;
    this.BravoTitle = item.bravoTitle;
    this.BravoDescription = item.bravoDescription;
    this.TargetDate = item.targetDate;
    this.StatusName = item.statusName;
    this.DevelopmentType = item.developmentType;
    this.StatusCategoryChangeDate = item.statusCategoryChangeDate;
  }

  static NameOfTheIdField() {
    return 'JiraIssueId';
  }

  static DateFields = ['IssueCreatedOn', 'TargetDate', 'StatusCategoryChangeDate'];
  static BoolFields = [];
  static MoneyFields = [];

  static Currency() {
    return '';
  }

  /** Statuses considered "in progress" (not yet released) */
  static InProgressStatuses = ['To Do', 'In Progress', 'Testing', 'UAT'];

  /** Statuses considered "released" */
  static ReleasedStatuses = ['Done', 'Released', 'Closed'];

  isInProgress() {
    return JiraIssueItem.InProgressStatuses.includes(this.StatusName);
  }

  isReleased() {
    return JiraIssueItem.ReleasedStatuses.includes(this.StatusName);
  }
}
